import React from 'react';
import { CheckCircle, ShieldCheck } from 'lucide-react';
import { EcheancierCarte } from './EcheancierCarte';
import { MandatSepaLigne } from './MandatSepaLigne';

const fr = (d) => (d ? new Date(d).toLocaleDateString('fr-FR') : '');

function PvReceptionStatut({ pv, id }) {
  if (!pv) {
    return <p className="text-[11px] font-semibold text-amber-700" data-testid={`domium-pv-statut-${id}`}>PV de réception sans réserves non déposé — déclaration de dommages bloquée</p>;
  }
  if (pv.en_cours) {
    return <p className="text-[11px] text-slate-600" data-testid={`domium-pv-statut-${id}`}>PV de réception en cours de lecture par l&apos;IA…</p>;
  }
  if (pv.sans_reserves) {
    return (
      <p className="text-[11px] font-semibold text-emerald-700" data-testid={`domium-pv-statut-${id}`}>
        PV sans réserves reconnu — réception le {fr(pv.date_reception)} · garantie jusqu&apos;au {fr(pv.fin_garantie)}
      </p>
    );
  }
  return (
    <p className="text-[11px] font-semibold text-red-700" data-testid={`domium-pv-statut-${id}`}>
      PV refusé par l&apos;IA — déclaration de dommages bloquée{pv.motifs?.length ? ` : ${pv.motifs.join(' ; ')}` : ''}
    </p>
  );
}

// Réglages figés du devis DOS-DOMIUM sur la carte du membre
export function DomiumParametresCarte({ sim }) {
  const validite = sim.date_validite ? new Date(sim.date_validite).toLocaleDateString('fr-FR') : null;
  return (
    <div className="mt-3 space-y-1.5 border-t border-orange-200 pt-3 text-xs" data-testid={`domium-parametres-${sim.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        {sim.deja_adherent && (
          <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-700" data-testid={`domium-deja-adherent-${sim.id}`}>
            <CheckCircle className="h-3 w-3" /> Déjà adhérent
          </span>
        )}
        {validite && <span className="text-gray-600" data-testid={`domium-validite-${sim.id}`}>Devis valable jusqu&apos;au <strong>{validite}</strong></span>}
      </div>
      {sim.garantie && (
        <p className="flex items-start gap-1 text-[11px] text-indigo-800" data-testid={`domium-garantie-${sim.id}`}>
          <ShieldCheck className="mt-px h-3 w-3 flex-shrink-0" /> {sim.garantie}
        </p>
      )}
      <PvReceptionStatut pv={sim.pv_reception} id={sim.id} />
      <div className="max-w-sm"><EcheancierCarte ech={sim.echelonnement} docId={sim.id} /></div>
      <div className="max-w-md"><MandatSepaLigne mandat={sim.mandat_sepa} docId={sim.id} /></div>
    </div>
  );
}
